import {Component, OnInit} from "@angular/core";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {DialogComponent} from "../../../../../ng2-bootstrap-modal/dialog.component";


@Component({
    selector: 'db-small-screen-disclaimer-dialog',
    templateUrl: './small-screen-disclaimer-dialog.component.html',
    styleUrls: ['./small-screen-disclaimer-dialog.component.scss'],
    standalone: false
})
export class SmallScreenDisclaimerDialogComponent extends DialogComponent<null, Boolean> implements OnInit  {

  public url = "https://www.youtube.com/embed/ttiAJHK8hKc?autoplay=1&cc_load_policy=1&modestbranding=1&iv_load_policy=3&showinfo=0";
  constructor(
    private _dialogService: DialogService
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
  }


}
